<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage sendUpload">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <p-toast key="toastmsg" position="top-right"></p-toast>
                    <form [formGroup]="sendNotificationForm" *ngIf="this.sendNotificationForm">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    {{pagetitle}}
                                </h3>
                            </div>
                        </div>

                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-12 uploadBtn">
                                    <label for="excelFile">User Excel <span class="mandatory-fields">*</span></label>
                                    <p-fileUpload chooseLabel="Upload" uploadLabel="Thumbnail Image"
                                        *ngIf="!userExcelSheet" cancelLabel="Cancel" accept=".xlsx,.csv"
                                        maxFileSize="{{imageSize}}" auto="auto" customUpload="true"
                                        (uploadHandler)="userExcelSheetUploader($event)"
                                        (onRemove)="removeUserExcelSheetFile($event)">
                                        <ng-template pTemplate="content">
                                            <span class="text-danger">Note:</span>
                                            <p>Download the sample Excel file for reference to match the exact format
                                                (columns, data types). This ensures smooth upload and processing—upload
                                                your file above once ready!</p>
                                            <a class="sampleBtn"
                                                href="../../../../assets/images/backend-image/Notification_Excel.xlsx"
                                                target="_blank" download>
                                                <span><img
                                                        src="../../../../assets/images/backend-image/common-images/excel.svg"
                                                        alt=""></span> Download Sample CSV
                                            </a>
                                            <span class="text-danger"
                                                *ngIf="submitted && f.excelFile?.errors?.required">User Excel Sheet is
                                                required</span>
                                        </ng-template>
                                    </p-fileUpload>
                                    <div class="actionList">
                                        <a [href]="userExcelSheet" *ngIf="userExcelSheet" target="_blank" download>
                                            <img src="../../../../assets/images/backend-image/common-images/excel.svg"
                                                alt="">
                                        </a>
                                        <button (click)="deleteExcelSheet()" class="deleteBtn" *ngIf="userExcelSheet"
                                            pTooltip="Delete Excel" tooltipPosition="top"><img
                                                src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                    </div>


                                </div>
                                <div class="p-field p-col-6 addFormDropDown">
                                    <label for="type">Type <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="type" [options]="pushNotificationTypes" formControlName="type"
                                        (onChange)="onClickNotificationType($event)" placeholder="Select Type"
                                        optionLabel="label" optionValue="value" [(ngModel)]="notificationType"
                                        [ngClass]="{ 'is-invalid': submitted && f.type.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.type.errors" class="invalid-feedback">
                                        <div *ngIf="f.type.errors.required">Type is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12 uploadBtn"
                                    *ngIf="notificationType === 'push_notification'">
                                    <label for="icon" style="font-family: Gilroy-SemiBold !important;
    font-weight: 400;
    font-style: ☞;
    font-size: 12px !important;
    leading-trim: CAP_HEIGHT;
    line-height: 120%;
    letter-spacing: 0%;
    text-transform: uppercase;
    color: #888888 !important;">Icon <span class="mandatory-fields">*</span></label>
                                    <!-- <p-fileUpload chooseLabel="Upload" uploadLabel="Thumbnail Image"
                                        *ngIf="notificationType === 'push_notification' && !notificationIcon"
                                        cancelLabel="Cancel" accept="image/*" maxFileSize="{{imageSize}}" auto="auto"
                                        customUpload="true" (uploadHandler)="iconUploader($event)"
                                        (onRemove)="removeIcon($event)">
                                        <ng-template pTemplate="content">
                                            <span class="text-danger" *ngIf="submitted && f.icon?.errors?.required">Icon
                                                is required</span>
                                        </ng-template>
                                    </p-fileUpload> -->
                                    <p-fileUpload #fileUpload mode="advanced" name="file" chooseLabel="Upload" uploadLabel="Thumbnail Image" cancelLabel="Cancel"
                                        *ngIf="notificationType === 'push_notification' && !notificationIcon" accept="image/*" maxFileSize="{{imageSize}}" auto="false" 
                                        customUpload="true" (onSelect)="onFileSelect($event)" (onRemove)="removeIcon($event)">
                                        <ng-template pTemplate="content">
                                        </ng-template>
                                    </p-fileUpload>
                                    <div class="p-field p-col-12" style="padding-left: 0px!important;">
                                        <div class="column banner-images col ng-star-inserted">
                                            <img [src]="notificationIcon" alt="Image not available"
                                        *ngIf="notificationType === 'push_notification' && notificationIcon"
                                       class="thumbnail-image" /> 
                                            <ul class="actionList">
                                                
                                                <li *ngIf="notificationType === 'push_notification' && notificationIcon"><button class="deleteBtn" (click)="deleteNotificationIcon()"><img
                                                            src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                                </li>
                                            </ul>
                                        </div>  
                                    </div> 
                                    <div class="instruction mt-3 mb-3" *ngIf="notificationType === 'push_notification'">
                                        <p>Instructions: </p>
                                        <ul>
                                            <li>1) The cropped Icon will be 100 x 100 px, with a maximum size of 1 MB.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="p-field p-col-12" *ngIf="notificationType === 'push_notification'">
                                    <label for="headerContent">Header <span class="mandatory-fields">*</span></label>
                                    <input formControlName="headerContent" type="text" pInputText class="form-control"
                                        placeholder="Enter Header"
                                        [ngClass]="{ 'is-invalid': submitted && f.headerContent.errors }">
                                    <div *ngIf="submitted && f.headerContent.errors" class="invalid-feedback">
                                        <div *ngIf="f.headerContent.errors.required">Header is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12" *ngIf="notificationType === 'push_notification'">
                                    <label for="description">Description <span class="mandatory-fields">*</span></label>
                                    <textarea inputId="textarea" formControlName="description" [rows]="5" [cols]="30"
                                        class="form-control" pInputTextarea placeholder="Enter Description"
                                        [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                    <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                        <div *ngIf="f.description.errors.required">Description is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-6" *ngIf="notificationType === 'email'">
                                    <label for="subject">Subject <span class="mandatory-fields">*</span></label>
                                    <input formControlName="subject" type="text" pInputText class="form-control"
                                        placeholder="Enter Subject"
                                        [ngClass]="{ 'is-invalid': submitted && f.subject.errors }">
                                    <div *ngIf="submitted && f.subject.errors" class="invalid-feedback">
                                        <div *ngIf="f.subject.errors.required">Subject is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12" *ngIf="notificationType === 'email'">
                                    <label for="emailContent">Template <span class="mandatory-fields">*</span></label>
                                    <textarea formControlName="emailContent" [rows]="15" [cols]="30"
                                        class="form-control" pInputTextarea placeholder="Enter HTML content here..."
                                        style="font-family: monospace; height: 320px;"
                                        [ngClass]="{ 'is-invalid': submitted && f.emailContent.errors }"></textarea>
                                    <div *ngIf="submitted && f.emailContent.errors" class="invalid-feedback">
                                        <div *ngIf="f.emailContent.errors.required">Template is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12">
                                    <h2 class="h2">Schedule</h2>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="scheduleDate">Date & Time <span
                                            class="mandatory-fields">*</span></label>
                                    <p-calendar appendTo="body" formControlName="scheduleDate" class="p-column-filter"
                                        monthNavigator="true" [minDate]="minDate" yearNavigator="true"
                                        yearRange="{{yearRange}}" dateFormat="dd-mm-yy" [readonlyInput]="true"
                                        [showIcon]="true" [hourFormat]="12" [showTime]="true"
                                        [ngClass]="{ 'is-invalid': submitted && f.scheduleDate.errors }">
                                    </p-calendar>
                                    <div *ngIf="submitted && f.scheduleDate.errors" class="invalid-feedback">
                                        <div *ngIf="f.scheduleDate.errors.required">Date & Time is required</div>
                                        <div *ngIf="f.scheduleDate.errors.minDate">Please select today's date and time
                                            or future date and time</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 statusdivMain">
                                    <label for="status">Status </label>
                                    <p-inputSwitch class="checkbox-mt-10" formControlName="status"
                                        [ngClass]="{ 'is-invalid': submitted && f.status.errors }"></p-inputSwitch>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Status is required</div>
                                    </div>
                                </div>

                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
                            <div class="p-formgrid p-grid">
                                <p-toast></p-toast>
                                <button type="text" (click)="onSubmit()" pButton icon="pi pi-check" label="Submit"
                                    class="p-button-success save-btn p-mr-3" style="width: auto"></button>
                                <button type="text" (click)="backLink()" pButton icon="pi pi-times" label="Cancel"
                                    class="p-button-danger cancel-btn" style="width: auto"></button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-set back">
                    <div class="p-fluid p-formgrid">
                        <p-toast></p-toast>
                    </div>
                </div>
            </div>
          <p-confirmDialog [style]="{width:'400px'}" id="confirmDialog"></p-confirmDialog>
        </div>
    </div>
    <p-dialog
        [(visible)]="cropDialog"
        [closable]="true"
        (onHide)="onDialogHide()"
        [modal]="true"
        [appendTo]="'body'"
        [style]="{width: '720px'}"
        [breakpoints]="{'768px': 'calc(100vw - 24px)'}"
        styleClass="custom-crop-dialog">
        <ng-template pTemplate="header">
            <div class="crop-header-wrapper">
                <div class="crop-header-icon-box">
                    <i class="pi pi-image header-icon"></i>
                </div>
                <div class="crop-header-text">
                    <h5 class="crop-dialog-title">{{cropDialogTitle}}</h5>
                    <p class="crop-dialog-subtitle">{{cropDialogSubtitle}}</p>
                </div>
            </div>
        </ng-template>

        <div class="crop-dialog-content-wrapper">
            <div class="crop-toolbar-bar mb-3">
                <div class="toolbar-hint">
                    <i class="pi pi-sliders-h mr-2 hint-icon"></i>
                    <span>Zoom & Scale</span>
                </div>
                    <div class="zoom-actions">
                    <button type="button" pButton icon="pi pi-search-plus" label="Zoom In" class="crop-btn zoom-btn"
                        (click)="zoomIn()"></button>
                    <button type="button" pButton icon="pi pi-search-minus" label="Zoom Out" class="crop-btn zoom-btn"
                        (click)="zoomOut()"></button>
                    <button type="button" pButton icon="pi pi-refresh" label="Reset" class="crop-btn reset-btn"
                        (click)="resetZoom()"></button>
                </div>
            </div>

            <div class="cropper-frame mb-3">
                <image-cropper
                    [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [aspectRatio]="1"
                    [resizeToWidth]="100"
                    [resizeToHeight]="100"
                    [onlyScaleDown]="false"
                    [imageQuality]="92"
                    [backgroundColor]="'#ffffff'"
                    [transform]="transform"
                    format="jpeg"
                    (imageCropped)="imageCropped($event)"
                    (loadImageFailed)="onCropImageLoadFailed()">
                </image-cropper>
            </div>

            <div class="crop-error-msg mb-3" *ngIf="croppedImageError">
                <i class="pi pi-exclamation-triangle mr-2"></i>
                <span>{{croppedImageError}}</span>
            </div>

            <div class="cropped-preview-box" *ngIf="croppedImage">
                <div class="preview-header">
                    <div class="preview-title">
                        <i class="pi pi-eye mr-2 text-primary"></i>
                        <span>Live Cropped Preview</span>
                    </div>
                    <span class="preview-ratio-badge">{{cropPreviewLabel}}</span>
                </div>
                <div class="preview-img-container">
                    <img [src]="croppedImage" alt="Cropped Notification Icon Preview" class="preview-img" />
                </div>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="dialog-footer-actions">
                <button type="button" pButton label="Cancel" icon="pi pi-times"
                    class="cancel-action-btn" (click)="onCropCancel()"></button>
                <button type="button" pButton label="Use Image" icon="pi pi-check"
                    class="use-image-btn" (click)="applyCrop()"
                    [disabled]="isApplyingCrop || !croppedImage || !!croppedImageError"></button>
            </div>
        </ng-template>
    </p-dialog>
</div>

